export default __webpack_public_path__ + "static/media/systemTool.929292e5.svg";